module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Panties-aecfe48f91aa96485c883c5bf329d2b1.svg";